import { TDevice } from '@cian/utils';

import { IPage } from '../../types/page';

const defaultState = {
  deviceType: 'phone' as TDevice,
};

export function pageReducer(state: IPage = defaultState) {
  return state;
}
